<template>
    <div class="t-center cart-empty">
        <svg viewBox="0 0 47 68" xmlns="http://www.w3.org/2000/svg">
            <g fill-rule="evenodd">
                <path
                    d="M34.2 19.7a.9.9 0 0 1-.9-1v-7.4c0-4.7-3.8-8.6-8.5-8.6a8.6 8.6 0 0 0-8.6 8.6v7.2a.9.9 0 1 1-1.8 0v-7.2C14.5 5.6 19.2 1 24.9 1S35 5.6 35 11.3v7.5c0 .5-.4.9-.9.9"></path>
                <path d="M1.8 66.1h34.6v-46H1.8v46zM0 68h38.1V18.3H.1V68z"></path>
                <path
                    d="M46.7 68H9.5a.9.9 0 0 1-.9-1c0-.5.4-.9 1-.9H45v-46H9.5a.9.9 0 0 1-.9-.9c0-.5.4-.9 1-.9h37.1V68"></path>
                <path
                    d="M12.6 53.8H28V40.4H12.6v13.4zm-1.8 1.8h18.9v-17H10.8v17zM29 26.3a.9.9 0 0 1-1-1V10.8c0-4.7-3.8-8.6-8.5-8.6a8.6 8.6 0 0 0-8.5 8.6v14.7c0 .5-.4.9-1 .9a.9.9 0 0 1-.8-1V10.8C9.2 5 13.8.3 19.5.3 25.2.3 29.8 5 29.8 10.7v14.7c0 .5-.4.9-.9.9M36.7 68l-.6-.3a1 1 0 0 1-.1-1.2l5.4-7.5 5.1 7c.3.3.2.9-.2 1.2-.4.3-1 .2-1.2-.2l-3.7-5-4 5.5c-.2.3-.5.4-.7.4"></path>
                <path
                    d="M41.5 61.4a.9.9 0 0 1-.9-1v-41c0-.5.4-1 1-1 .4 0 .8.5.8 1v41c0 .6-.4 1-.9 1M10.2 26.5c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zm0 5a3.4 3.4 0 0 1-3.4-3.4c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4zM29 26.5c-.8 0-1.5.7-1.5 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zm0 5a3.4 3.4 0 0 1-3.3-3.4c0-1.9 1.5-3.4 3.4-3.4a3.4 3.4 0 1 1 0 6.9z"></path>
            </g>
        </svg>
        <div class="color-grey mt-2 fs-xl">В корзине ничего нет.</div>
        <div class="mb-3 color-grey cart-empty-subtitle">Узнать больше о наших продуктах и услугах
            вы можете в <a
                href="/products/">разделе продуктов</a></div>
        <a href="/" class="btn outline mr-1">На главную</a>
        <a href="/products/" class="btn ml-1">Продукты</a>
    </div>
</template>

<script>
export default {
    name: "EmptyCart"
}
</script>